module.exports = __webpack_public_path__ + "static/media/img3.4a3e4609.jpeg";